// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CategoriesResponse, Category } from '../models/category';
import { ConfigService } from '@coa/app/core/services/config.service';

@Injectable({
  providedIn: 'root',
})
export class SelectCategoryService {

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  getCategories(clientId: string): Observable<CategoriesResponse> {
    const url = this.configService.getConfig().analyticsApi + '/categories';
    const params = new HttpParams()
      .set('clientId', clientId.toString());

    return this.httpClient.get<CategoriesResponse>(url, {params}).pipe(
      map((categories: Category[]) => categories.map((category) => ({...category, id: category.id.toString()}))),
    );
  }
}

